/**
 * Scroll to a specific element.
 *
 * @param {string|Element} selector One element or a selector for one element
 * @param {int} margin Default: 1 the margin from the top of the element
 * @returns
 */
export const scroll_to = ( selector, margin = 1 ) => {
	const el = (selector instanceof Element ? selector : document.querySelector(selector));

	if (!el || el.style.display === 'none') {
		return;
	}

	const elTop = el.getBoundingClientRect().top + window.scrollY - margin;

	window.scrollTo({ top: elTop, behavior: 'smooth' });
};